/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */
import { MSEnum } from '@/common/enumeration';
import msDateUtil from '@/components/msdatepicker/msDateUtil';
import { update } from 'lodash';
import commonFunction from '@/common/commonFunction';

export default {
    updateInvoiceRisk(state, res) {
        let result = res.data;
        state.InvoiceRisk = result.Data || [];
        if (res.isGetTotal) {
            // API có lấy ds hóa đơn có lấy thông tin tổng hóa đơn
            state.InvoiceRiskTotal = result.Total;
        } else if (result.Total) {
            state.InvoiceRiskTotal = result.Total ? result.Total : state.InvoiceRiskTotal;
        }
    },
    updateTotalInvoieRiskPage(state, res) {
        state.InvoiceRiskTotal = res || 0;
    },
    updateLoadingTotalInvoiceRiskRecords(state, res) {
        state.IsLoadingTotalInvoiceRiskRecords = res;
    },
    resetDataListInvoiceRisk(state, res) {
        state.InvoiceRisk = [];
        state.InvoiceRiskTotal = 0;
    },
    resetDataInvoiceStick(state) {
        state.InvoiceStick = [];
        state.InvoiceStickTotal = 0;
        state.InvoiceListForStickTotal = 0;
    },
    updateInvoiceSupplierActive(state, res) {
        let result = res.data;
        state.InvoiceSupplierActives = result.Data || [];
        if (res.isGetTotal) {
            // API có lấy ds hóa đơn có lấy thông tin tổng hóa đơn
            state.InvoiceSupplierActiveTotal = result.Total;
        } else if (result.Total) {
            state.InvoiceSupplierActiveTotal = result.Total ? result.Total : state.InvoiceSupplierActiveTotal;
        }
    },
    updateTotalInvoieSupplierActivePage(state, res) {
        state.InvoiceSupplierActiveTotal = res || 0;
    },
    updateLoadingInvoiceSupplierActive(state, res) {
        state.IsLoadingInvoiceSupplierActiveTotal = res;
    },
    resetDataListInvoiceSupplierActive(state, res) {
        state.InvoiceSupplierActives = [];
        state.InvoiceSupplierActiveTotal = 0;
    },
    reportinvoicerelated(state, res) {
        let result = res.data;
        state.InvoiceRelateds = result.Data || [];
        if (res.isGetTotal) {
            // API có lấy ds hóa đơn có lấy thông tin tổng hóa đơn
            state.InvoiceRelatedTotal = result.Total;
        } else if (result.Total) {
            state.InvoiceRelatedTotal = result.Total ? result.Total : state.InvoiceRelatedTotal;
        }
    },
    updateTotalInvoieRelatedPage(state, res) {
        state.InvoiceRelatedTotal = res || 0;
    },
    updateLoadingTotalInvoiceRelatedRecords(state, res) {
        state.IsLoadingInvoiceRelatedTotal = res;
    },
    resetDataListInvoiceRelated(state, res) {
        state.InvoiceRelateds = [];
        state.InvoiceRelatedTotal = 0;
    },

    /**
     * Update loading tổng số bản ghi báo cáo tổng hợp chi phí
     * @author dqduy 16.01.2025
     * @param {*} state
     * @param {*} res
     */
    updateLoadingTotalCostTypeSummaryRecords(state, res) {
        state.IsLoadingCostTypeSummaryReportTotal = res;
    },

    /**
     * Update tổng số bản ghi báo cáo tổng hợp chi phí
     * @author dqduy 16.01.2025
     * @param {*} state
     * @param {*} res
     */
    updateTotalCostTypeSummaryPage(state, res) {
        state.CostTypeSummaryReportTotal = res || 0;
    },

    /**
     * Update dữ liệu báo cáo tổng hợp chi phí
     * @author dqduy 16.01.2025
     * @param {*} state
     * @param {*} res
     */
    updateCostTypeSummary(state, res) {
        let result = res.data;
        state.DataCostTypeSummaryReport = result.Data || [];
        if (res.isGetTotal) {
            // API có lấy ds hóa đơn có lấy thông tin tổng hóa đơn
            state.CostTypeSummaryReportTotal = result.Total;
        } else if (result.Total) {
            state.CostTypeSummaryReportTotal = result.Total ? result.Total : state.CostTypeSummaryReportTotal;
        }
    },

    /**
     * Reset dữ liệu báo cáo tổng hợp chi phí
     * @author dqduy 16.01.2025
     * @param {*} state
     * @param {*} res
     */
    resetDataListCostTypeSummary(state, res) {
        state.DataCostTypeSummaryReport = [];
        state.CostTypeSummaryReportTotal = 0;
    },

    /**
     * Update loading tổng số bản ghi báo cáo hóa đơn vượt định mức chi phí
     * @author dqduy 16.01.2025
     * @param {*} state
     * @param {*} res
     */
    updateLoadingTotalExceedCostRecords(state, res) {
        state.IsLoadingReportExceedCostTotal = res;
    },

    /**
     * Update loading tổng số bản ghi báo cáo loại chi phí và định mức chi phí
     * @param {*} state
     * @param {*} res
     * @author dqduy 10.02.2025
     */
    updateLoadingTotalTypeAndCostRecords(state, res) {
        state.IsLoadingTypeAndCostTotal = res;
    },

    /**
     * Reset dữ liệu báo cáo hóa đơn vượt định mức chi phí
     * @author dqduy 16.01.2025
     * @param {*} state
     * @param {*} res
     */
    resetDataExceedCost(state, res) {
        state.DataReportExceedCost = [];
        state.ReportExceedCostTotal = 0;
    },

    /**
     * Reset dữ liệu báo cáo hóa đơn loại chi phí và định mức
     * @author dqduy 10.02.2025
     */
    resetDataTypeAndCost(state, res) {
        state.DataTypeAndCost = [];
        state.TypeAndCostTotal = 0;
    },

    /**
     * Update tổng số bản ghi báo cáo vượt định mức chi phí
     * @author dqduy 16.01.2025
     * @param {*} state
     * @param {*} res
     */
    updateTotalExceedCostPage(state, res) {
        state.ReportExceedCostTotal = res || 0;
    },

    /**
     * Update tổng số bản ghi báo cáo loại chi phí và định mức chi phí
     * @param {*} state
     * @param {*} res
     * @author dqduy 10.02.2025
     */
    updateTotalTypeAndCostPage(state, res) {
        state.TypeAndCostTotal = res || 0;
    },

    /**
     * Update dữ liệu báo cáo hóa đơn vượt định mức chi phí
     * @author dqduy 16.01.2025
     * @param {*} state
     * @param {*} res
     */
    updateExceedCost(state, res) {
        let result = res.data;
        state.DataReportExceedCost = result.Data || [];
    },

    /**
     * update dữ liệu báo cáo loại chi phí và định mức
     * @author dqduy 10.02.2025
     * @param {*} state
     * @param {*} res
     */
    updateTypeAndCost(state, res) {
        let result = res.data;
        state.DataTypeAndCost = result.Data || [];
        state.DataTypeAndCostDataPage = commonFunction.skipTakeData(state.DataTypeAndCost, res.skip, res.take);
        if (res.isGetTotal) {
            // API có lấy ds hóa đơn có lấy thông tin tổng hóa đơn
            state.TypeAndCostTotal = result.Total;
        } else if (result.Total) {
            state.TypeAndCostTotal = result.Total ? result.Total : state.TypeAndCostTotal;
        }
    },

    updateInvoiceByNormTotal(state, res) {
        state.InvoiceByNormTotal = res || 0;
    },

    updateInvoiceByNorm(state, res) {
        state.InvoiceByNorm = res.Data || [];
    },

    /**
     * Afterkey phục vụ paging
     * @param {*} state
     * @param {*} res
     */
    updateAfterKeys(state, res) {
        state.AfterKeyValues = res.AfterKeyValues || null;
    },

    updateInvoiceReportStick(state, res) {
        let result = res.data;
        state.InvoiceStick = result.Data || [];
    },

    updateTotalInvoiceStickPage(state, res) {
        state.InvoiceStickTotal = res;
    },

    updateLoadingInvStick(state, res) {
        state.IsLoadingTotalInvoiceRiskRecords = res;
    },

    updateTotalInvoiceListForStick(state, res) {
        state.InvoiceListForStickTotal = res;
    },

    /**
     * Cập nhật tổng số hóa đơn vượt ngưỡng
     * @param {Object} state - Vuex state
     * @param {Number} res - Tổng số hóa đơn
     * @author dqduy 11.2025
     */
    updateInvoiceExceedTotal(state, res) {
        state.InvoicesExceedTotal = res || 0;
    },

    /**
     * Cập nhật danh sách hóa đơn vượt ngưỡng 5 triệu
     * @param {Object} state - Vuex state
     * @param {Object} res - Response data từ API chứa danh sách hóa đơn
     * @author dqduy 11.2025
     */
    updateListInvoicesExceed(state, res) {
        state.ListInvoicesExceed = res.Data || [];
    },
};